export default __webpack_public_path__ + "static/media/chop-life-hero.34018bbb.jpg";